// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","orderStatus":"G67da3f"};